// utils/ticketOptions.ts

import { GATicket } from "@features/eventPage/types";
import { uniqBy } from "lodash";

export const filterAndMapTicketOptions = (
  data: GATicket | undefined,
  gaAreaIds: number[],
  priceSectionIds: number[],
  isExtraAddOns: boolean
) => {
  if (!data) return [];

  return uniqBy(
    data?.TicketOptions?.filter((to) =>
      isExtraAddOns
        ? to.IsExtra
        : to.GAAreaId
        ? gaAreaIds.includes(to.GAAreaId) &&
          priceSectionIds.includes(to.PriceSectionId) &&
          !to.IsExtra
        : priceSectionIds.includes(to.PriceSectionId) && !to.IsExtra
    ).map((to) => ({
      id: to.IsCombo
        ? `combo-${to.ComboId}`
        : `${to.GAAreaId}-${to.PriceSectionId}-${to.PriceAgeId}`,
      gaAreaId: to.GAAreaId,
      priceSectionId: to.PriceSectionId,
      priceAgeId: to.PriceAgeId,
      priceId: to.PriceId,
      type: to.Name,
      info: to.IsCombo ? to.Description : to.PriceAgeDescription,
      price: to.Price,
      discountPrice: to.DiscountPrice,
      min: to.MinTickets ?? 0,
      max: to.MaxTickets,
      minPrice: to.Price,
      maxPrice: to.Price,
      priceMinimum: to.PriceMinimum,
      priceMaximum: to.PriceMaximum,
      bookedTickets: to.IsCombo
        ? to.NumberOfTimesUsed
        : to.BookedTicketIds && to.BookedTicketIds.length > 0
        ? to.BookedTicketIds.filter((id) => id.ComboId === null).length
        : 0,
      bookedFromCombo:
        to.BookedTicketIds && to.BookedTicketIds.length > 0
          ? to.BookedTicketIds.filter((id) => id.ComboId !== null).length
          : 0,
      bookingLimit: to.BookingLimit,
      isCombo: to.IsCombo,
      status: to.AvailabilityStatus,
      comboId: to.ComboId,
      isExtra: to.IsExtra,
      isPromo: to.IsPromo,
      areaName: to.AreaName,
      priceSchemeName: to.PriceSchemeName ? to.PriceSchemeName.trim() : "",
      priceSectionName: to.PriceSectionName ? to.PriceSectionName.trim() : "",
      currency: data.Currency,
      priceAgeStartDate: to.PriceAgeStartDate,
      priceAgeEndDate: to.PriceAgeEndDate,
      order: to.Ordering,
    })),
    "id"
  );
};
